// components/ConfirmationDialog.tsx
import React, { useEffect } from 'react'

import WarningIcon from '@mui/icons-material/Warning' // Import the icon
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

import CustomButton from './CustomButton'

interface ConfirmationDialogProps {
  open: boolean
  onClose: (confirmed: boolean) => void
  title?: string
  content?: string
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  title = 'Confirmation',
  content = 'Are you sure you want to proceed?'
}) => {
  const handleConfirm = () => {
    onClose(true)
  }

  const handleCancel = () => {
    onClose(false)
  }

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!open) return

      if (event.key === 'Enter') {
        event.preventDefault()
        handleConfirm()
      }
    }

    if (open) {
      document.addEventListener('keydown', handleKeyDown)
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [open])

  return (
    <Dialog open={open}>
      <DialogTitle style={{ textAlign: 'center' }}>{title}</DialogTitle>
      <DialogContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <WarningIcon style={{ fontSize: 50, color: '#f44336', marginBottom: 16 }} className='custom-icon-size' />
        <p>{content}</p>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'center' }}>
        <CustomButton variant='contained' color='primary' type='button' onClick={handleConfirm} loading={false}>
          Yes
        </CustomButton>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationDialog
